function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF704E",
  fillRule: "evenodd",
  d: "M11.297 12.25v1.25c0 1.379-1.122 2.5-2.5 2.5H2.516c-1.379 0-2.5-1.121-2.5-2.5v-11c0-1.379 1.121-2.5 2.5-2.5h6.28c1.38 0 2.5 1.121 2.5 2.5v1.25c0 .345-.279.625-.624.625s-.625-.28-.625-.625V2.5c0-.69-.56-1.25-1.25-1.25H2.516c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h6.28c.69 0 1.25-.56 1.25-1.25v-1.25c0-.345.28-.625.626-.625.345 0 .625.28.625.625zm4.261-5.324l-1.4-1.4c-.244-.243-.64-.243-.883 0-.245.245-.245.64 0 .885l.995.995H6.766c-.346 0-.625.28-.625.625s.28.625.625.625h7.504l-.995.996c-.245.244-.245.64 0 .884.122.122.282.183.441.183.16 0 .32-.061.443-.183l1.399-1.4c.61-.61.61-1.6 0-2.21z"
});

var SvgLogOut = function SvgLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/log-out.5d1fef7f.svg";
export { ForwardRef as ReactComponent };